import React from 'react';
import ReactDOM from 'react-dom';
import i18n from './app/i18n';
import Main from './app/Main';

ReactDOM.render(<Main />, document.getElementById('root'));
